import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap, concatMap, take } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { Message } from '@core/models/message.model';

@Injectable()
export class MessageDataService extends DefaultDataService<Message> {

  pagination: Pagination;

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('Message', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<Message[]>{
    return this.http.get<ApiResponse>(`/message${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getMemberMessages(params:string) {
    return this.http.get<ApiResponse>(`/member/messages${params}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
